import React from 'react';
import { useSettings } from '../context/SettingsContext';
import { Shield } from 'lucide-react';

const PageHeader = ({ title, subtitle, icon: Icon }) => {
  const { settings, getLogoUrl } = useSettings();
  const logoUrl = getLogoUrl();

  return (
    <div className="flex items-center gap-4">
      {/* Logo - Larger size */}
      <div 
        className="w-16 h-16 rounded-sm flex items-center justify-center overflow-hidden shrink-0"
        style={{ backgroundColor: `${settings.primary_color}20` }}
      >
        {logoUrl ? (
          <img 
            src={logoUrl} 
            alt={settings.app_title} 
            className="w-full h-full object-contain p-2"
          />
        ) : (
          <Shield className="w-9 h-9" style={{ color: settings.primary_color }} />
        )}
      </div>
      
      {/* Title */}
      <div>
        <h1 className="font-chivo font-black text-2xl md:text-3xl tracking-tight uppercase text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="font-mono text-xs tracking-widest uppercase text-muted-foreground mt-0.5">
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
